import Vue from 'vue'
import { ValidacaoConsistenciaMessagesFactory } from '../../factories/ValidacaoConsistenciaMessagesFactory'
import Message from '../ui/message/Message.vue'
export function useChartTooltip() {
	// Verifica se o ponto existe e tem as propriedades necessárias
	if (!this.point || !this.point.insights || !this.point.validacaoConsistencia) {
		return ''
	}

	const messageHtml = this.point.insights.map(
		(insight) =>
			new Vue({
				...Message,
				propsData: { hideIcon: true, size: 'sm', type: 'warning', description: insight.message },
			}).$mount().$el.outerHTML,
	)

	const validacaoMessages = this.point.validacaoConsistencia.map(
		(validacao) =>
			new Vue({
				...Message,
				propsData: {
					hideIcon: true,
					size: 'sm',
					type: 'info',
					description: ValidacaoConsistenciaMessagesFactory.make(validacao).short.message,
				},
			}).$mount().$el.outerHTML,
	)

	return `<div class="w-[500px]">
        <div class="text-xs-bold">
          ${this.point.estrato}
          •
          ${this.point.fazenda}
          •
          ${this.point.talhao}
          •
          ${this.point.parcela}
        </div>
        <div>
          <span class="mt-2 text-xs-bold">Medições<span>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
              Altura
            </span>
            <span class="text-xs">
              ${this.point.ht?.toFixed(2) || 0} m
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
              DAP/CAP
            </span>
            <span class="text-xs">
              ${this.point.dap?.toFixed(2) || 0} cm
            </span>
          </div>
          <div class="flex w-full justify-between ${this.point.diametroCopa ? 'block' : 'hidden'}">
            <span class="text-xs-trv">
              Diâmetro da copa
            </span>
            <span class="text-xs">
              ${Number(this.point.diametroCopa)?.toFixed(2) || 0} cm
            </span>
          </div>
        </div>
        <div>
          <span class="mt-2 text-xs-bold">Categorias<span>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv flex items-center gap-1">
              <div class="h-3 w-3 rounded-full" style="background-color: ${this.point.corCategoriaArvore}"></div>
            ${this.point.categoriaDaArvore}
            </span>
          </div>
          <div class="flex w-full justify-between ${this.point.categoriaFitossanidade ? 'block' : 'hidden'}">
            <span class="text-xs-trv flex items-center gap-1">
              <div class="h-3 w-3 rounded-full" style="background-color: ${this.point.corCategoriaFitossanidade}"></div>
            ${this.point.categoriaFitossanidade}
            </span>
            <span class="text-xs">
              ${this.point.intensidadeFitossanidade ? this.point.intensidadeFitossanidade + '%' : '-'}
            </span>
          </div>
        </div>
        <div>
          <span class="mt-2 text-xs-bold">Mato competição (linha)<span>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Área coberta
            </span>
            <span class="text-xs">
              ${this.point.coberturaMatoLinha || 0}%
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Altura do mato
            </span>
            <span class="text-xs">
              ${this.point.alturaMatoLinha || 0}%
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Tipo de mato dominante
            </span>
            <span class="text-xs">
              ${this.point.tipoMatoDominante || 'N/A'}
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Tipo de mato associado
            </span>
            <span class="text-xs">
              ${this.point.tipoMatoAssociado || 'N/A'}
            </span>
          </div>
        </div>
      <div>
          <span class="mt-2 text-xs-bold">Mato competição (entrelinha)<span>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Área coberta
            </span>
            <span class="text-xs">
              ${this.point.coberturaMatoEntrelinha || 0}%
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Altura do mato
            </span>
            <span class="text-xs">
              ${this.point.alturaMatoEntrelinha || 0}%
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Tipo de mato dominante
            </span>
            <span class="text-xs">
              ${this.point.matoDominanteEntrelinha || 'N/A'}
            </span>
          </div>
          <div class="flex w-full justify-between">
            <span class="text-xs-trv">
            Tipo de mato associado
            </span>
            <span class="text-xs">
              ${this.point.matoAssociadoEntrelinha || 'N/A'}
            </span>
          </div>
          </div>

          <div class="w-full flex gap-2 flex-col justify-center items-center">
            <p class="my-3">Nível de Risco: <strong>${this.point.nivelRisco}<strong></p>
            <ul class='w-full flex flex-col gap-1'>
            ${validacaoMessages
							.map((message) => `<li>${message}</li>`)
							.toString()
							.split(',')
							.join(' ')}
            </ul>
            <ul class='w-full flex my-2 flex-col gap-1'>
              ${messageHtml
								.map((message) => `<li>${message}</li>`)
								.toString()
								.split(',')
								.join(' ')}
            </ul>
          </div>
      </div>`
}
